import { CustomIconProps } from './index';

export const TextIcon = ({ color }: CustomIconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            fill="none"
            viewBox="0 0 24 24">
            <circle
                cx={12}
                cy={12}
                r={11}
                fill="#fff"
                stroke={color || 'black'}
                strokeWidth={2}
            />
            <path
                fill={color || 'black'}
                d="M6 7h8v2H6zm7 4h6v2h-6zM9 9h2v8H9zm6 4h2v4h-2z"
            />
        </svg>
    );
};
